import { PROJECT_PROPOSAL } from '../type'

const initialState = {
  data: null,
  isLoading: false,
  error: null,
}

export function projectProposal(state = initialState, action) {
  switch (action.type) {
    case PROJECT_PROPOSAL.REQUEST:
      return { ...state, error: null, data: null, isLoading: true }
    case PROJECT_PROPOSAL.SUCCESS:
      return {
        ...state,
        error: null,
        data: action.payload,
        id: action.payload.id,
        isLoading: false,
      }
    case PROJECT_PROPOSAL.FAILURE:
      return { ...state, error: action.error, data: null, isLoading: false }
    default:
      return state
  }
}
